var ImgStatisticsConfig = /** @class */ (function () {
    function ImgStatisticsConfig() {
        var _this = this;
        this.formatters = {};
        this.renderers = {};
        this.getFormatter = function (name) {
            return _this.formatters[name];
        };
        this.setFormatter = function (name, formatter) {
            _this.formatters[name] = formatter;
        };
        this.getRenderer = function (name) {
            return _this.renderers[name];
        };
        this.setRenderer = function (name, renderer) {
            _this.renderers[name] = renderer;
        };
        this.renderAsSVG = false;
    }
    ImgStatisticsConfig.getInstance = function () {
        if (!this.instance)
            this.instance = new ImgStatisticsConfig();
        this.instance.formatters.interpolate = function (data, payload) {
            var f = function () {
                return new Function("return `" + payload + "`;").call(data);
            };
            return f();
        };
        return this.instance;
    };
    ImgStatisticsConfig.debug = false;
    return ImgStatisticsConfig;
}());
export { ImgStatisticsConfig };
//# sourceMappingURL=ImgStatisticsConfig.js.map